var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"app":"","color":"bgPrimary","elevation":"1","dense":""}},[_c('v-spacer'),_c('u-upload-popup'),_c('u-notification-popup'),_c('u-profile-popup',{attrs:{"image":_vm.image,"firstName":_vm.firstName,"lastName":_vm.lastName,"subtitle":_vm.subtitle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }